/**
 * Returns the currency with the highest total spend in a spend-by-currency map.
 */
export const getPrimarySpendCurrency = (spendByCurrency = {}) => {
  const entries = Object.entries(spendByCurrency).filter(
    ([, amount]) => Number(amount) > 0
  );

  if (!entries.length) {
    return null;
  }

  return entries.sort((a, b) => Number(b[1]) - Number(a[1]))[0][0];
};

export default getPrimarySpendCurrency;
